import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useAuth } from '../../../../../context/AuthContext';
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

export const AdminCreateSchool = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const { t } = useTranslation()
    const [imagePath, setImagePath] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const [members, setMembers] = useState([]);
    const [loadingMembers, setLoadingMembers] = useState(true);
    const [memberSearch, setMemberSearch] = useState("");
    const [selectedMemberEmail, setSelectedMemberEmail] = useState("");

    const headerss = {
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + user.token
    };

    useEffect(() => {
        const fetchMembers = async () => {
            setLoadingMembers(true);
            try {
                const url = `${API_BASE_URL}/admin/User/GetUsers`;
                const res = await axios({ method: 'GET', url, headers: headerss });

                if (res.status === 200 && res.data['success']) {
                    const list = (res.data['data'] || [])
                        .map(item => ({
                            username: item.user.username,
                            fullName: item.user.fullName,
                            createdAt: item.user.createdAt,
                            schoolId: item.detail?.schoolId || null
                        }))
                        .sort((a, b) => {
                            const aHasSchool = a.schoolId ? 1 : 0;
                            const bHasSchool = b.schoolId ? 1 : 0;
                            if (aHasSchool !== bHasSchool) return aHasSchool - bHasSchool;
                            return new Date(b.createdAt) - new Date(a.createdAt);
                        });
                    setMembers(list);
                } else {
                    setMsg(res.data['message'] || "Üye listesi alınamadı.");
                }
            } catch (err) {
                setMsg(err.message);
            }
            setLoadingMembers(false);
        };
        fetchMembers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const term = memberSearch.trim().toLowerCase();
        const match = members.find(m => (m.username || "").toLowerCase() === term);
        setSelectedMemberEmail(match ? match.username : "");
    }, [memberSearch, members]);

    const selectedMember = members.find(m => m.username === selectedMemberEmail) || null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            let url = `${API_BASE_URL}/admin/School/Create`;
            const res = await axios({
                method: 'Post',
                url: url,
                data: {
                    schoolName: document.getElementById("schoolName").value,
                    schoolLogo: imagePath,
                },
                headers: headerss
            });

            if (res.status === 200 && res.data['success']) {
                const newSchoolId = res.data['data']?.id;

                if (selectedMemberEmail && newSchoolId) {
                    const assignRes = await axios({
                        method: 'Get',
                        url: `${API_BASE_URL}/admin/School/AssignManager`,
                        params: {
                            email: selectedMemberEmail,
                            schoolId: newSchoolId,
                        },
                        headers: headerss
                    });

                    if (assignRes.data['success']) {
                        Swal.fire({
                            title: "Başarılı!",
                            text: "Okul oluşturuldu ve seçilen üye yönetici olarak atandı.",
                            icon: "success",
                            confirmButtonText: `Tamam`
                        });
                    } else {
                        Swal.fire({
                            title: "Okul oluşturuldu ama yönetici atanamadı",
                            text: assignRes.data['message'] || "Okulu schoollist sayfasından manuel atayabilirsiniz.",
                            icon: "warning",
                            confirmButtonText: `Tamam`
                        });
                    }
                } else {
                    Swal.fire({
                        title: "Başarılı!",
                        icon: "success",
                        confirmButtonText: `Tamam`
                    });
                }

                document.getElementById("schoolName").value = "";
                setSelectedMemberEmail("");
                setMemberSearch("");
            }
            else {
                Swal.fire({
                    title: "error!",
                    icon: "error",
                    confirmButtonText: `Tamam`
                });
                setMsg(res.data['message']);
            }
        } catch (err) {
            setMsg(err.message);
        }
        setSubmitting(false);
    }



    const handleChange = async (event) => {
        const formData = new FormData();
        formData.append('FormFile', event.target.files[0]);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            const url = `${API_BASE_URL}/admin/ContentFile/UploadFile`; // API_BASE_URL kullanımı
            await axios({
                method: 'Post',
                url: url,
                params: {
                    mediaType: "photo"
                },
                data: formData,
                headers: headerss
            }).then(res => {
                setImagePath(res.data['data']['path'])
                alert("Yüklendi")

            });
        } catch (err) {
            console.log(err)
            setMsg(err.message);
        }
    }


    return (
        <div style={{ backgroundColor: "white", padding: "3%" }}>
            <h4>{msg}</h4>
            <div style={{ textAlign: "center" }}>
                <h1>{t("createSchool")}</h1>
            </div>

            <form onSubmit={handleSubmit} >

                <div className="mb-3">
                    <label for="schoolName" className="form-label">{t("schoolName")}</label>
                    <textarea className="form-control" id="schoolName" required />
                </div>

                <div className="mb-3">
                    <label for="schoollogo" className="form-label">{t("schoolImage")}</label> <i>minumum 1280*720 pixel boyutlarında önerilir.</i>
                    <input className="form-control" type="file" accept='image/png, image/jpg, image/jpeg' onChange={handleChange} id="imagePath1" name="schoollogo" required />
                </div>

                <hr />

                <div className="mb-3">
                    <label className="form-label">Üye Listesinden Yönetici Seç (isteğe bağlı)</label>
                    <p className="text-muted" style={{ fontSize: "0.85rem" }}>
                        Bu okulun ilk yönetici hesabı olarak mevcut bir bireysel üyeyi seçebilirsiniz. Boş bırakırsanız
                        yöneticiyi daha sonra okul listesi sayfasından atayabilirsiniz.
                    </p>

                    <input
                        type="text"
                        className="form-control mb-2"
                        placeholder={loadingMembers ? "Üyeler yükleniyor..." : "İsim veya e-posta ile ara..."}
                        value={memberSearch}
                        onChange={(e) => setMemberSearch(e.target.value)}
                        disabled={loadingMembers}
                        list="memberSearchSuggestions"
                        autoComplete="off"
                    />
                    <datalist id="memberSearchSuggestions">
                        {members.map((m) => (
                            <option key={m.username} value={m.username}>
                                {m.fullName}{m.schoolId ? " (zaten bir okulda)" : ""}
                            </option>
                        ))}
                    </datalist>

                    {memberSearch && (
                        selectedMember ? (
                            <div className="alert alert-success py-2 mb-0">
                                Seçildi: <strong>{selectedMember.fullName}</strong> - {selectedMember.username}
                                {selectedMember.schoolId ? " (zaten bir okulda, yeniden atanacak)" : ""}
                            </div>
                        ) : (
                            <div className="alert alert-warning py-2 mb-0">
                                Eşleşen bir üye yok. Önerilen listeden tam e-posta adresini seçin.
                            </div>
                        )
                    )}
                </div>

                <div className='d-flex justify-content-center'>
                    <button type="submit" className="btn btn-primary btn-lg" disabled={submitting}>
                        {submitting ? "Oluşturuluyor..." : t("create")}
                    </button>
                </div>
            </form>
        </div>
    )
}
export default AdminCreateSchool;
